import DibsStorage, { localStorage, sessionStorage } from '../src/BrowserStorage';
export { localStorage, sessionStorage };
export default DibsStorage;
